export const FAVORITE_CHANNEL_IDS_KEY = "iptv-streamer.favoriteChannelIds";

interface FavoriteStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function readFavoriteChannelIds(storage = getBrowserStorage()): Set<string> {
  if (!storage) {
    return new Set();
  }

  try {
    const value = storage.getItem(FAVORITE_CHANNEL_IDS_KEY);
    const parsed: unknown = value ? JSON.parse(value) : [];
    if (!Array.isArray(parsed)) {
      return new Set();
    }

    return new Set(parsed.filter((id): id is string => typeof id === "string" && id.length > 0).sort());
  } catch {
    return new Set();
  }
}

export function writeFavoriteChannelIds(favoriteIds: ReadonlySet<string>, storage = getBrowserStorage()): void {
  if (!storage) {
    return;
  }

  storage.setItem(FAVORITE_CHANNEL_IDS_KEY, JSON.stringify([...favoriteIds].sort()));
}

export function toggleFavoriteChannelId(favoriteIds: ReadonlySet<string>, channelId: string): Set<string> {
  const next = new Set(favoriteIds);
  if (next.has(channelId)) {
    next.delete(channelId);
  } else {
    next.add(channelId);
  }

  return next;
}

function getBrowserStorage(): FavoriteStorage | undefined {
  return typeof window === "undefined" ? undefined : window.localStorage;
}
